<div class="loader d-flex align-content-center flex-wrap animated fadeIn">
    <div class="loadBar"></div>
    <div class="message">
        <h2>Please Wait</h2>
        <p>{{message}}</p>
    </div>
</div>